/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

customerSelectorToolbarStyles.wrapper = {
    css: css`
        display: flex;
        border-bottom: 1px solid ${getColor("common.border")};
        padding-bottom: 15px;

        ${screen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex-basis: 50%;

            ${screen("lt", "sm")} {
                flex-basis: 100%;
                margin-bottom: 10px;
            }
        `,
    },
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;

        &&& {
            ${screen("lt", "sm")} {
                width: 100%;
            }
        }
    `,
};
